// src/data/Menu.js

// Définition des rôles
export const ROLES = {
    SUPER_ADMIN: 'Super Administrateur',
    ADMIN: 'Administrateur',
    PASTEUR: 'Pasteur',
    ANCIEN: 'Ancien',
    DIACRE: 'Diacre',
    DIACONESSE: 'Diaconesse',
    DP: 'DP',
    ACCUEIL: 'Accueil',
    NOUVEAU: 'Nouveau',
    MEMBRE: 'Membre'
};

// Fonction pour générer le menu en fonction du rôle
export const getDashboardMenu = (user) => {
    const userRole = user?.role; // Récupère le rôle de l'utilisateur

    // Menu de base avec les rôles autorisés pour chaque élément
    const baseMenu = [
        // Tableau de bord
        {
            label: "Tableau de bord",
            link: "/dashboard",
            icon: "ri-dashboard-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE, 
                ROLES.ANCIEN, 
                ROLES.DP
            ]
        },
        
        // Membres
        {
            label: "Membres",
            icon: "ri-group-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE, 
                ROLES.ANCIEN, 
                ROLES.DP, 
                ROLES.ACCUEIL, 
                ROLES.NOUVEAU,
                ROLES.MEMBRE
            ],
            submenu: [
                { 
                    label: "Liste des membres", 
                    link: "/membres/liste", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE, 
                        ROLES.ANCIEN, 
                        ROLES.DP, 
                        ROLES.ACCUEIL, 
                        ROLES.NOUVEAU,
                        ROLES.MEMBRE
                    ] 
                },
                { 
                    label: "Ajouter un membre", 
                    link: "/membres/ajouter", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR
                    ] 
                },
                { 
                    label: "Import/Export", 
                    link: "/membres/import", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR
                    ] 
                },
                // { 
                //     label: "Pasteurs", 
                //     link: "/membres/role/pasteurs", 
                //     roles: [
                //         ROLES.SUPER_ADMIN, 
                //         ROLES.ADMIN, 
                //         ROLES.PASTEUR, 
                //         ROLES.DIACRE, 
                //         ROLES.DIACONESSE, 
                //         ROLES.ANCIEN, 
                //         ROLES.DP
                //     ] 
                // },
                // { 
                //     label: "Anciens & DP", 
                //     link: "/membres/role/dp", 
                //     roles: [
                //         ROLES.SUPER_ADMIN, 
                //         ROLES.ADMIN, 
                //         ROLES.PASTEUR, 
                //         ROLES.DIACRE, 
                //         ROLES.DIACONESSE, 
                //         ROLES.ANCIEN, 
                //         ROLES.DP
                //     ] 
                // },
                { 
                    label: "Recommandations", 
                    link: "/recommandations/liste", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR
                    ] 
                },
                { 
                    label: "Nouv. recommand.", 
                    link: "/recommandations/nouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR
                    ] 
                }
            ]
        },
        
        // Églises & Abonnements
        {
            label: "Églises & Temples",
            icon: "ri-building-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE, 
                ROLES.ANCIEN, 
                ROLES.DP
            ],
            submenu: [
                { 
                    label: "Liste des églises", 
                    link: "/eglises/sieges", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN 
                  
                    ] 
                },
                { 
                    label: "Ajouter une église", 
                    link: "/eglises/ajouter", 
                    roles: [ROLES.SUPER_ADMIN] // SEULEMENT Super Admin
                },
                { 
                    label: "Liste des temples", 
                    link: "/temples/liste", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE, 
                        ROLES.ANCIEN, 
                        ROLES.DP
                    ] 
                },
                { 
                    label: "Ajouter un temple", 
                    link: "/eglises/ajouter-temple", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR
                    ] 
                },
                { 
                    label: "Liste abonnements", 
                    link: "/abonnements/liste", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN
                    ] 
                },
                { 
                    label: "Nouvel abonnement", 
                    link: "/abonnementsNouveau", 
                    roles: [ROLES.SUPER_ADMIN] // SEULEMENT Super Admin
                },
                { 
                    label: "Abonnements expirés", 
                    link: "/abonnementsExpire", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN
                    ] 
                }
            ]
        },


        // Dans la section appropriée de votre menu (par exemple après Finances ou avant Paramètres)
{
    label: "Patrimoine",
    icon: "ri-building-2-line",
    roles: [
        ROLES.SUPER_ADMIN, 
        ROLES.ADMIN, 
        ROLES.PASTEUR, 
        ROLES.ANCIEN, 
        ROLES.DIACRE, 
        ROLES.DIACONESSE,
        ROLES.DP, 
        ROLES.ACCUEIL
    ],
    submenu: [
        { 
            label: "Liste patrimoines", 
            link: "/patrimoines/liste", 
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.ANCIEN, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE,
                ROLES.DP, 
                ROLES.ACCUEIL
            ] 
        },
        { 
            label: "Ajouter patrimoine", 
            link: "/patrimoinesAjouter", 
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.ANCIEN, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE
            ] 
        }
    ]
},
        
        // Finances
        {
            label: "Finances",
            icon: "ri-money-euro-circle-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE
            ],
            submenu: [
                { 
                    label: "Liste des entrées", 
                    link: "/finances/entrees", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                },
                { 
                    label: "Nouvelle entrée", 
                    link: "/finances/entreesNouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                },
                { 
                    label: "Types de revenus", 
                    link: "/finances/typesRevenus", 
                    roles: [
                        ROLES.SUPER_ADMIN
                    ] 
                },
                { 
                    label: "Liste des dépenses", 
                    link: "/finances/depenses", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                },
                { 
                    label: "Nouvelle dépense", 
                    link: "/finances/depensesNouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                },
                { 
                    label: "Types de dépenses", 
                    link: "/finances/typesDepenses", 
                    roles: [
                        ROLES.SUPER_ADMIN
                    ] 
                },
                { 
                    label: "Bilan mensuel", 
                    link: "/finances/bilanMensuel", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                },
                { 
                    label: "Bilan annuel", 
                    link: "/finances/bilanAnnuel", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                }
            ]
        },
        
        // Événements
        {
            label: "Événements",
            icon: "ri-calendar-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.ANCIEN, 
                ROLES.DP, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE, 
                ROLES.ACCUEIL, 
                ROLES.NOUVEAU,
                ROLES.MEMBRE
            ],
            submenu: [
                { 
                    label: "Assistances", 
                    link: "/evenements/assistances", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DP, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE, 
                        ROLES.ACCUEIL, 
                        ROLES.NOUVEAU,
                        ROLES.MEMBRE
                    ] 
                },
                { 
                    label: "Nouvelle assistance", 
                    link: "/evenements/assistances/nouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.DP, 
                        ROLES.ACCUEIL
                    ] 
                },
                { 
                    label: "Mariages", 
                    link: "/evenements/mariages", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DP, 
                        ROLES.ACCUEIL, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.NOUVEAU,
                        ROLES.MEMBRE
                    ] 
                },
                { 
                    label: "Nouveau mariage", 
                    link: "/evenements/mariagesNouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.ANCIEN, 
                        ROLES.DP, 
                        ROLES.ACCUEIL
                    ] 
                },
                { 
                    label: "Baptêmes", 
                    link: "/evenements/baptemes", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.DP, 
                        ROLES.ACCUEIL, 
                        ROLES.NOUVEAU,
                        ROLES.MEMBRE
                    ] 
                },
                { 
                    label: "Nouveau baptême", 
                    link: "/evenements/baptemesNouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.DP, 
                        ROLES.ACCUEIL
                    ] 
                },
                { 
                    label: "Naissances", 
                    link: "/evenements/naissances", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.DP, 
                        ROLES.ACCUEIL, 
                        ROLES.NOUVEAU,
                        ROLES.MEMBRE
                    ] 
                },
                { 
                    label: "Nouvelle naissance", 
                    link: "/evenements/naissancesNouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.ANCIEN, 
                        ROLES.DP, 
                        ROLES.ACCUEIL
                    ] 
                },
                { 
                    label: "Décès", 
                    link: "/evenements/deces", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.DP, 
                        ROLES.ACCUEIL, 
                        ROLES.NOUVEAU,
                        ROLES.MEMBRE
                    ] 
                },
                { 
                    label: "Nouveau décès", 
                    link: "/evenements/decesNouveau", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE,
                        ROLES.ANCIEN, 
                        ROLES.DP, 
                        ROLES.ACCUEIL
                    ] 
                }
            ]
        },
        
        // Statistiques
        {
            label: "Statistiques",
            icon: "ri-bar-chart-2-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR, 
                ROLES.DIACRE, 
                ROLES.DIACONESSE, 
                ROLES.ANCIEN, 
                ROLES.DP
            ],
            submenu: [
                { 
                    label: "Dashboard général", 
                    link: "/stats/dashboard", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE, 
                        ROLES.ANCIEN, 
                        ROLES.DP
                    ] 
                },
                { 
                    label: "Membres", 
                    link: "/stats/membres", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE, 
                        ROLES.ANCIEN, 
                        ROLES.DP
                    ] 
                },
                { 
                    label: "Nouveaux membres", 
                    link: "/stats/membresEvolution", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE, 
                        ROLES.ANCIEN, 
                        ROLES.DP
                    ] 
                },
                { 
                    label: "Finances", 
                    link: "/stats/finances", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.DIACRE, 
                        ROLES.DIACONESSE
                    ] 
                },
                { 
                    label: "Evénements", 
                    link: "/stats/evenements", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN, 
                        ROLES.PASTEUR, 
                        ROLES.ANCIEN, 
                        ROLES.DP
                    ] 
                },
                { 
                    label: "Abonnements", 
                    link: "/stats/abonnements", 
                    roles: [
                        ROLES.SUPER_ADMIN, 
                        ROLES.ADMIN
                    ] 
                }
            ]
        },
        
        // Paramètres
        {
            label: "Paramètres",
            icon: "ri-settings-3-line",
            roles: [
                ROLES.SUPER_ADMIN, 
                ROLES.ADMIN, 
                ROLES.PASTEUR
            ],
            submenu: [
                { 
                    label: "Sauvegarde manuelle", 
                    link: "/parametres/sauvegarde/manuel", 
                    roles: [ROLES.SUPER_ADMIN] // SEULEMENT Super Admin
                },
                { 
                    label: "Restauration", 
                    link: "/parametres/sauvegarde/restauration", 
                    roles: [ROLES.SUPER_ADMIN] // SEULEMENT Super Admin
                }
            ]
        }
    ];

    // Fonction pour vérifier si l'utilisateur a le rôle requis
    const hasRole = (requiredRoles) => {
        if (!requiredRoles || requiredRoles.length === 0) return true;
        return requiredRoles.includes(userRole);
    };

    // Filtrer le menu selon le rôle de l'utilisateur
    return baseMenu
        .filter(item => hasRole(item.roles))
        .map(item => {
            // Filtrer aussi les sous-menus
            if (item.submenu) {
                const filteredSubmenu = item.submenu.filter(subItem => hasRole(subItem.roles));
                return {
                    ...item,
                    submenu: filteredSubmenu
                };
            }
            return item;
        })
        .filter(item => {
            // Supprimer les items sans sous-menu si c'est un menu déroulant
            if (item.submenu && item.submenu.length === 0) return false;
            return true;
        });
};